import React from 'react'
import logo from './logo-bot.png'

export default function Navbar() {
   
    return (
        <div className="headers headers-fixed">
            <div class="navbar container">
                <img src={logo} class="logo-img" alt="" />
                <div class="logo"><a href="./index.html">STUDYBOT</a></div>
                <input type="checkbox" id="navbar-toggle" />
                <label for="navbar-toggle"><i></i></label>
                <nav class="menu">
                    <ul>
                        <li><a href="./index.html" class="links" style={{ color: 'white' }}>Home</a></li>
                        <li><a href="https://docs.google.com/forms/d/e/1FAIpQLSca_7mjft0JOHvw6R-3V0EEqSPI257D58oFl8uhh77f5GCDOw/viewform" class="links" style={{ color: 'white' }}>Get Involved</a></li>
                        <li><a href="#" class="links" style={{ color: 'white' }}>About Us</a></li>
                        <li><a href="#" class="links" style={{ color: 'white' }}>Social Media</a></li>
                    </ul>
                </nav>
            </div>
        </div>
    )
}